import { textureLoaderWall } from "./textureLoader";
import { getAllEntityData, getEntityData } from "../operate/operateApi";
import { setTotalFloor } from "@/rlMxModules/operate/init";
import store from "@/store/index";
import {
  getrlStdFlrAll,
  getRlLayer,
  getrlFloor,
  getrlStdFlr,
  getRlInitFloorData,
} from "@/mixins/LiteModuleDb.js";
import { getNonStructuralColor } from "@/rlMxModules/operate/structural";

let levelData = null;
let prevData = [];
// 将实体数据添加到组中
const IMG_ORIENTATION_MAP = {
  front: 2,
  right: 1,
  back: -1,
  top: 0,
  bottom: -1,
  left: 3,
};

const coordConfig = {
  threshold: 0.85,
  axes: {
    top: { axis: "z", direction: 1 },
    bottom: { axis: "z", direction: -1 },
    front: { axis: "x", direction: 1 },
    back: { axis: "x", direction: -1 },
    right: { axis: "y", direction: 1 },
    left: { axis: "y", direction: -1 },
  },
};

const rotationRules = {
  top: Math.PI, // 仅back方向镜像的基础旋转，旋转靠UV实现
  bottom: 0,
  front: (faceVertices, orientation) => {
    const isXDirection = isWallAlongXAxis(faceVertices);
    return isXDirection ? 0 : Math.PI / 2;
  },
  back: (faceVertices, orientation) => {
    const isXDirection = isWallAlongXAxis(faceVertices);
    return isXDirection ? 0 : Math.PI / 2;
  },
  left: (faceVertices, orientation) => {
    const isYDirection = isWallAlongYAxis(faceVertices);
    return isYDirection ? 0 : Math.PI / 2;
  },
  right: (faceVertices, orientation) => {
    const isYDirection = isWallAlongYAxis(faceVertices);
    return isYDirection ? 0 : Math.PI / 2;
  },
  unknown: 0,
};

function isWallAlongXAxis(faceVertices) {
  const yValues = faceVertices.map((v) => v.y);
  const yRange = Math.max(...yValues) - Math.min(...yValues);
  const xValues = faceVertices.map((v) => v.x);
  const xRange = Math.max(...xValues) - Math.min(...xValues);
  return yRange < xRange * 0.1;
}

function isWallAlongYAxis(faceVertices) {
  const xValues = faceVertices.map((v) => v.x);
  const xRange = Math.max(...xValues) - Math.min(...xValues);
  const yValues = faceVertices.map((v) => v.y);
  const yRange = Math.max(...yValues) - Math.min(...yValues);
  return xRange < yRange * 0.1;
}

export const addrlEntityGroup = (group, isFu) => {
  // 获取所有实体数据
  let getData = getAllEntityData(true);
  if (!getData || getData.length == 0) return;
  // 过滤掉 _threeObj 为 null 或 undefined 的数据
  getData = getData.filter((item) => {
    return item._threeObj !== null && item._threeObj !== undefined;
  });

  if (isFu) {
    // 只保留新的数据
    if (prevData.length > 0) {
      getData = getData.filter((item) => {
        return !prevData.some((prevItem) => prevItem.Guid === item.Guid);
      });
    }
    // 更新上一次的数据
    prevData.push(...getData);
  }
  // 按照 componentType 分组

  const groupedData = new Map();
  getData.forEach((item) => {
    if (!groupedData.has(item.componentType)) {
      groupedData.set(item.componentType, []);
    }
    groupedData.get(item.componentType).push(item);
  });
  // 遍历分组后的数据

  groupedData.forEach((items) => {
    // 创建合并后的几何体
    const mergedGeometry = new THREE.BufferGeometry();
    const positionData = [];
    const indexData = [];
    // 遍历每个实体的三维对象
    items.forEach((item) => {
      // 获取实体的顶点位置数据和索引数据
      const positions = item._threeObj.geometry.attributes.position.array;
      const indices = item._threeObj.geometry.index?.array;
      // 计算顶点位置数据的偏移量
      const offset = positionData.length / 3;
      positionData.push(...positions);
      indexData.push(...indices.map((i) => i + offset));
    });
    // 设置合并后几何体的顶点位置属性和索引
    mergedGeometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(positionData, 3)
    );
    mergedGeometry.setIndex(indexData);
    // 计算合并后几何体的法线
    mergedGeometry.computeVertexNormals();
    // 获取第一个实体的材质
    const material = items[0]._threeObj.material;
    // 创建合并后的网格
    const mergedMesh = new THREE.Mesh(mergedGeometry, material);
    // 设置合并后网格的缩放
    mergedMesh.scale.set(0.0001, 0.0001, 0.0001);
    // 设置合并后网格的可见性
    mergedMesh.visible = items[0].visible;
    // 设置合并后网格的旋转
    mergedMesh.rotation.x = -Math.PI / 2;
    mergedMesh.rotation.z = Math.PI;
    // 添加边线
    const edges = new THREE.EdgesGeometry(mergedGeometry);
    const edgeMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });
    const edgeObject = new THREE.LineSegments(edges, edgeMaterial);
    mergedMesh.add(edgeObject);
    // 将合并后的网格添加到组中
    group.add(mergedMesh);
  });
};

const createGroupDataMash = (group, groupedData, specialMeshes = []) => {
  specialMeshes.forEach((mesh) => {
    group.add(mesh);
  });

  groupedData.forEach((items) => {
    const mergedGeometry = new THREE.BufferGeometry();
    const positionData = [];
    const indexData = [];
    let firstModel = null;
    // 创建合并后的几何体

    items.forEach((item) => {
      // 获取实体的顶点位置数据和索引数据

      if (item) {
        if (!firstModel) firstModel = item;
        const positions = item.geometry.attributes.position.array;
        const indices = item.geometry.index?.array;
        // 计算顶点位置数据的偏移量

        const offset = positionData.length / 3;
        positionData.push(...positions);
        indexData.push(...indices.map((i) => i + offset));
      }
    });
    if (firstModel) {
      // 设置合并后几何体的顶点位置属性和索引

      mergedGeometry.setAttribute(
        "position",
        new THREE.Float32BufferAttribute(positionData, 3)
      );
      mergedGeometry.setIndex(indexData);
      // 计算合并后几何体的法线

      mergedGeometry.computeVertexNormals();
      // 获取第一个实体的材质

      const material = firstModel.material;
      // 创建合并后的网格

      const mergedMesh = new THREE.Mesh(mergedGeometry, material);
      // 设置合并后网格的缩放

      mergedMesh.scale.set(0.0001, 0.0001, 0.0001);
      mergedMesh.visible = firstModel.visible;
      // 设置合并后网格的旋转

      mergedMesh.rotation.x = -Math.PI / 2;
      mergedMesh.rotation.z = Math.PI;
      // 添加边线

      const edges = new THREE.EdgesGeometry(mergedGeometry);
      const edgeMaterial = new THREE.LineBasicMaterial({ color: 0x000000 });
      const edgeObject = new THREE.LineSegments(edges, edgeMaterial);
      mergedMesh.add(edgeObject);
      // 将合并后的网格添加到组中

      group.add(mergedMesh);
    }
  });
};

export const clearScene = () => {
  // 遍历场景中的所有对象,释放几何体、材质、纹理等资源

  rlThreeObj.Tscene.traverse((obj) => {
    if (obj.geometry) obj.geometry?.dispose();
    if (obj.material) {
      if (obj.material instanceof Array) {
        obj.material.forEach((e) => {
          if (e.map) {
            e.map.dispose();
            console.log("[缓存清理] 纹理已销毁");
          }
          e.dispose();
        });
      } else if (obj.material.materials) {
        obj.material.materials.forEach((e) => {
          if (e.map) e.map.dispose();
          e.dispose();
        });
      } else {
        if (obj.material.map) obj.material.map.dispose();
        obj.material?.dispose();
      }
    }
    if (obj.texture) obj.texture?.dispose();
  });
  // 移除场景中的所有子对象

  while (rlThreeObj.Tscene.children.length > 0) {
    rlThreeObj.Tscene.remove(rlThreeObj.Tscene.children[0]);
  }
};
// 更新三维场景

export const update3Dview = async () => {
  // 清空场景

  clearScene();
  let group = new THREE.Group();

  // 创建一个新的组

  if (!store.state.globalData.isBldg) {
    // 将实体数据添加到组中
    // await addrlEntityGroup(group);

    await drawFloor3dData(group, store.state.globalData.rl_stdFlr_id);
    // 将组添加到场景中

    rlThreeObj.Tscene.add(group);
  } else if (store.state.globalData.isBldg) {
    await drawFloor3dData(group);
    // 将组添加到场景中

    rlThreeObj.Tscene.add(group);
  }
  // 创建一个新的包围盒
  let boundingBox = new THREE.Box3();

  // 遍历所有的子对象
  for (let i = 0; i < rlThreeObj.Tscene.children.length; i++) {
    // 计算子对象的包围盒并合并到总的包围盒中

    boundingBox.expandByObject(rlThreeObj.Tscene.children[i]);
  }
  // 获取包围盒的中心点
  let center = boundingBox.getCenter(new THREE.Vector3());
  rlThreeObj.Tcontrols.target.copy(center);
  let size = boundingBox.getSize(new THREE.Vector3());
  // 设置相机的位置
  rlThreeObj.Tcamera.position.set(
    center.x,
    center.y + size.y * 1.5, // 高度
    center.z - size.z * 1.5 //距离
  );
  // 渲染场景
  rlThreeObj.Trenderer.render(rlThreeObj.Tscene, rlThreeObj.Tcamera);

  //绘制整栋模型
  // setTimeout(() => {
  //   rlThreeObj.Trenderer.render(rlThreeObj.Tscene, rlThreeObj.Tcamera);
  //   console.log("[场景渲染] 第二次强制渲染，确保left面效果生效");
  // }, 300);
};

function processCubeGeometry(originalPoints, originalFaces) {
  const newPositions = [];
  const newUVs = [];
  const newIndices = [];
  let vertexIndex = 0;
  const facesCount = 6;
  const faceOrientations = [];

  for (let faceIdx = 0; faceIdx < facesCount; faceIdx++) {
    const faceStart = faceIdx * 6;
    const tri1Indices = originalFaces.slice(faceStart, faceStart + 3);
    const tri2Indices = originalFaces.slice(faceStart + 3, faceStart + 6);
    const allFaceIndices = [...tri1Indices, ...tri2Indices];
    const uniqueIndices = [...new Set(allFaceIndices)];

    if (uniqueIndices.length !== 4) {
      faceOrientations.push("unknown");
      continue;
    }

    const getPoint = (idx) => ({
      x: originalPoints[idx * 3],
      y: originalPoints[idx * 3 + 1],
      z: originalPoints[idx * 3 + 2],
      idx: idx,
    });
    const vertices = uniqueIndices.map(getPoint);
    const faceCenter = {
      x: vertices.reduce((sum, v) => sum + v.x, 0) / 4,
      y: vertices.reduce((sum, v) => sum + v.y, 0) / 4,
      z: vertices.reduce((sum, v) => sum + v.z, 0) / 4,
    };

    const [v0, v1, v2] = vertices.slice(0, 3);
    const edge1 = { x: v1.x - v0.x, y: v1.y - v0.y, z: v1.z - v0.z };
    const edge2 = { x: v2.x - v0.x, y: v2.y - v0.y, z: v2.z - v0.z };
    const normal = {
      x: edge1.y * edge2.z - edge1.z * edge2.y,
      y: edge1.z * edge2.x - edge1.x * edge2.z,
      z: edge1.x * edge2.y - edge1.y * edge2.x,
    };
    const toCenter = {
      x: faceCenter.x - v0.x,
      y: faceCenter.y - v0.y,
      z: faceCenter.z - v0.z,
    };
    const dot =
      normal.x * toCenter.x + normal.y * toCenter.y + normal.z * toCenter.z;
    const isInside = dot > 0;
    if (isInside) {
      normal.x = -normal.x;
      normal.y = -normal.y;
      normal.z = -normal.z;
    }

    vertices.sort((a, b) => {
      const va = {
        x: a.x - faceCenter.x,
        y: a.y - faceCenter.y,
        z: a.z - faceCenter.z,
      };
      const vb = {
        x: b.x - faceCenter.x,
        y: b.y - faceCenter.y,
        z: b.z - faceCenter.z,
      };
      const cross = {
        x: va.y * normal.z - va.z * normal.y,
        y: va.z * normal.x - va.x * normal.z,
        z: va.x * normal.y - va.y * normal.x,
      };
      const dotA = cross.x * vb.x + cross.y * vb.y + cross.z * vb.z;
      return dotA > 0 ? -1 : 1;
    });

    const pA = [vertices[0].x, vertices[0].y, vertices[0].z]; // X最小（靠近back）
    const pB = [vertices[1].x, vertices[1].y, vertices[1].z];
    const pC = [vertices[2].x, vertices[2].y, vertices[2].z];
    const pD = [vertices[3].x, vertices[3].y, vertices[3].z]; // X最大（远离back）

    const orientation = getFaceOrientation([
      vertices[0],
      vertices[1],
      vertices[2],
    ]);
    faceOrientations.push(orientation);
    let uvA = [0, 0],
      uvB = [0, 1],
      uvC = [1, 1],
      uvD = [1, 0];
    if (faceIdx === 4) {
      // left面
      uvA = [1, 0];
      uvB = [1, 1];
      uvC = [0, 1];
      uvD = [0, 0];
      console.log(
        `[leftUV] 保持原有配置：uvA=${uvA}, uvB=${uvB}, uvC=${uvC}, uvD=${uvD}`
      );
    } else if (faceIdx === 0) {
      //  top面UV：
      // 逻辑：UV的u/v交换（实现90度旋转）+ u轴反向（实现back镜像）
      // uvA = [1, 0]; // pA（靠近back）→ 纹理(1,0)：u反向（镜像）+ v=0（旋转后垂直方向）
      // uvB = [1, 1]; // pB → 纹理(1,1)
      // uvC = [0, 1]; // pC → 纹理(0,1)
      // uvD = [0, 0]; // pD（远离back）→ 纹理(0,0)：u反向（镜像）
      (uvA = [0, 1]), (uvB = [0, 0]), (uvC = [1, 0]), (uvD = [1, 1]);
      console.log(
        `[topUV] 已实现back镜像+90度旋转：uvA=${uvA}, uvB=${uvB}, uvC=${uvC}, uvD=${uvD}`
      );
    }
    if (faceIdx == 2) {
      // front面：纹理向右移动0.1个单位
      const offsetU = 0;
      uvA = [0 + offsetU, 0];
      uvB = [0 + offsetU, 1];
      uvC = [1 + offsetU, 1];
      uvD = [1 + offsetU, 0];
      console.log(`front面(面${faceIdx})纹理向右移动${offsetU}`);
    }

    newPositions.push(...pA, ...pB, ...pC);
    newUVs.push(...uvA, ...uvB, ...uvC);
    newIndices.push(vertexIndex, vertexIndex + 1, vertexIndex + 2);
    vertexIndex += 3;

    newPositions.push(...pA, ...pC, ...pD);
    newUVs.push(...uvA, ...uvC, ...uvD);
    newIndices.push(vertexIndex, vertexIndex + 1, vertexIndex + 2);
    vertexIndex += 3;
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute(
    "position",
    new THREE.Float32BufferAttribute(newPositions, 3)
  );
  geometry.setAttribute("uv", new THREE.Float32BufferAttribute(newUVs, 2));
  geometry.setIndex(newIndices);
  geometry.computeVertexNormals();

  const indicesPerFace = 6;
  for (let i = 0; i < facesCount; i++) {
    geometry.addGroup(i * indicesPerFace, indicesPerFace, i);
    geometry.groups[i].userData = {
      orientation: faceOrientations[i],
      isLeftFace: i === 4,
      isTopFace: i === 0,
    };
  }

  return geometry;
}

const drawFloor3dData = async (group, floorGuid = null) => {
  //从IndexDB中拿出所有数据

  let modelSortArray = await getFloor3dData(floorGuid);
  if (modelSortArray) {
    //获取构件的图层颜色

    let rlLayer = await getRlLayer();
    const rlLayerMap = rlLayer.reduce((acc, item) => {
      acc[item.Type] = item.Color;
      return acc;
    }, {});

    const groupedData = new Map();
    const specialMeshes = [];
    for (let key in modelSortArray) {
      let tempKey = key;
      //去掉数字和连字符
      let modelArray = modelSortArray[key];
      //获取数字和连字符
      key = key.replace(/[\d-]/g, "");
      let num = tempKey.replace(key, "");
      let color = rlLayerMap[key];
      if (key == "rlSlab") color = rlLayerMap["rlSlabSeg"];

      for (let i = 0; i < modelArray.length; i++) {
        let model = modelArray[i].data;
        let drawing3DData =
          model.Drawing_3D && JSON.parse(model.Drawing_3D)
            ? JSON.parse(model.Drawing_3D)
            : null;

        if (drawing3DData) {
          let points = drawing3DData.points.map((item, index) => {
            if (index % 3 === 2) {
              return item + modelArray[i].LevelB;
            }
            return item;
          });
          let modelType = key;
          let objThree = null;

          if (model.RoomIsHole || modelType == "rlSlabHole") {
            objThree = await create3dModel(points, drawing3DData.faces, {
              r: 173,
              g: 153,
              b: 153,
              a: 1,
            });
            modelType = "rlSlabHole";
          } else if (
            modelType == "rlPartitionWallSeg" ||
            modelType == "rlDoorsWindows"
          ) {
            let TempColor = getNonStructuralColor(Number(model.Mat));
            //更改modeltype为了可以不同的材质显示不同的颜色
            //model.Mat:51砖,52玻璃,53:金属,54轻质材料,55:人造板材,56:其他
            objThree = await create3dModel(
              points,
              drawing3DData.faces,
              TempColor
            );
            modelType = modelType + "_" + model.Mat;
          } else if (modelType == "rlBeamSeg") {
            if (model.Attribute != 1) {
              color = rlLayerMap["rlSubBeam"];
              modelType = "rlSubBeam";
            } else {
              color = rlLayerMap["rlBeamSeg"];
            }

            if (
              store.state.rlEntData.hasCrackGuid &&
              store.state.rlEntData.hasCrackGuid[model.Guid]
            ) {
              const imgs = store.state.rlEntData.hasCrackGuid[model.Guid];
              modelType = modelType + num + "_special_" + model.Guid;
              const faceTextures = generateFaceTexturesByOrientation(imgs);
              if (
                isExtendedAlongXAxis({
                  points,
                  faces: drawing3DData.faces,
                })
              ) {
                const res = convertToRefFormat({
                  points,
                  faces: drawing3DData.faces,
                });
                objThree = await create3dModel(
                  res.points,
                  res.faces,
                  color,
                  true,
                  faceTextures
                );
              } else {
                objThree = await create3dModel(
                  res.points,
                  drawing3DData.faces,
                  color,
                  true,
                  faceTextures
                );
              }
              if (objThree) {
                objThree.scale.set(0.0001, 0.0001, 0.0001);
                objThree.rotation.x = -Math.PI / 2;
                objThree.rotation.z = Math.PI;
                const edges = new THREE.EdgesGeometry(objThree.geometry);
                const edgeMaterial = new THREE.LineBasicMaterial({
                  color: 0x000000,
                });
                const edgeObject = new THREE.LineSegments(edges, edgeMaterial);
                objThree.add(edgeObject);
                specialMeshes.push(objThree);
              }
            } else {
              objThree = await create3dModel(
                points,
                drawing3DData.faces,
                color
              );
            }
          } else {
            objThree = await create3dModel(points, drawing3DData.faces, color);
          }

          if (
            objThree &&
            !(
              store.state.rlEntData.hasCrackGuid &&
              store.state.rlEntData.hasCrackGuid[model.Guid]
            )
          ) {
            modelType = modelType + num;
            if (groupedData.has(modelType)) {
              groupedData.get(modelType).push(objThree);
            } else {
              groupedData.set(modelType, [objThree]);
            }
          }
        }
      }
    }
    // 遍历分组后的数据
    createGroupDataMash(group, groupedData, specialMeshes);
  }
};
//获取所有楼层的3D模型数据
function generateFaceTexturesByOrientation(imgs) {
  const orientations = ["top", "bottom", "front", "back", "left", "right"];
  const faceTextures = [];
  orientations.forEach((orient) => {
    const imgIndex = IMG_ORIENTATION_MAP[orient];
    if (imgIndex >= 0 && imgs[imgIndex]) {
      faceTextures.push(imgs[imgIndex]);
    } else {
      faceTextures.push("");
    }
  });
  return faceTextures;
}

const getFloor3dData = async (floorGuid = null) => {
  // 获取自然层数据

  let rlTotalFloor = await getrlFloor();
  if (rlTotalFloor) {
    if (floorGuid) {
      rlTotalFloor = rlTotalFloor.filter(
        (item) => item.StdFlrGuid == floorGuid
      );
    }
    let modelSortArray = {};

    for (const floor of rlTotalFloor) {
      if (!floor || !floor.StdFlrGuid) {
        continue;
      }
      // 获取当前楼层底标高
      if (!floor || !floor.StdFlrGuid) continue;
      let floorModelData = await getrlStdFlr(floor.StdFlrGuid);
      if (!floorModelData) continue;
      let LevelB = floor.LevelB;

      for (const key of Object.keys(floorModelData)) {
        if (floorModelData[key]) {
          let item = floorModelData[key];
          if (
            key === "rlWallSeg" ||
            key === "rlBeamSeg" ||
            key === "rlColSeg" ||
            key === "rlRingBeamSeg" ||
            key === "rlSlab" ||
            key === "rlSlabHole" ||
            key === "rlSubBeam" ||
            key === "rlWallHole" ||
            key === "rlPartitionWallSeg" ||
            key === "rlDoorsWindows" ||
            key === "rlCantiSlab"
          ) {
            // 并发处理当前类型的所有模型数据
            await Promise.all(
              Object.keys(item).map(async (k) => {
                if (item[k] && item[k].Drawing_3D) {
                  if (!modelSortArray[key + floor.No_])
                    modelSortArray[key + floor.No_] = [];
                  modelSortArray[key + floor.No_].push({
                    data: item[k],
                    LevelB: LevelB,
                  });
                }
              })
            );
          }
        }
      }
    }
    return modelSortArray;
  }
  return null;
};

function debugLog(message) {
  // console.log(`[Three.js 调试] ${message}`);
}

async function create3dModel(
  point,
  indexData,
  Color,
  isShowCrack = false,
  faceTextures = [],
  emissiveColor = { r: 244, g: 67, b: 54, a: 255 }
) {
  // debugLog(
  //   "开始创建3D模型：顶点数=" +
  //     point.length / 3 +
  //     "，面数=" +
  //     indexData.length / 6
  // );

  if (!isShowCrack) {
    const geometry = new THREE.BufferGeometry();
    const material = new THREE.MeshBasicMaterial({ transparent: true });

    let vertices = [];
    if (point.every((value) => typeof value === "number" && !isNaN(value))) {
      vertices = new Float32Array(point);
    }
    geometry.setAttribute("position", new THREE.BufferAttribute(vertices, 3));
    geometry.setIndex(indexData);

    material.color = new THREE.Color(
      Color.r / 255,
      Color.g / 255,
      Color.b / 255
    );
    material.opacity = Color.a || 1;
    material.transparent = (Color.a || 1) == 1 ? false : true;
    material.side = THREE.DoubleSide;

    const mesh = new THREE.Mesh(geometry, material);
    return mesh;
  }

  const geometry = processCubeGeometry(point, indexData);
  const materials = [];

  for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
    const texturePath = faceTextures[faceIndex] || "";
    let material;
    const isLeftFace = faceIndex === 4;
    const isTopFace = faceIndex === 0;
    const isFront = faceIndex === 2;
    if (texturePath && texturePath.trim()) {
      const { hasImage, texture } = await loadCubeFaceTexture(
        texturePath,
        Color,
        emissiveColor,
        faceIndex,
        geometry
      );

      if (hasImage && texture) {
        material = new THREE.MeshBasicMaterial({
          map: texture,
          side: THREE.DoubleSide,
          transparent: false,
          polygonOffset: true,
          polygonOffsetFactor: 1,
          polygonOffsetUnits: 1,
          needsUpdate: true,
        });
        if (isLeftFace || isTopFace) {
          material.needsUpdate = true;
          console.log(`[${isLeftFace ? "left" : "top"}材质] 已强制启用更新`);
        }
      } else {
        material = new THREE.MeshBasicMaterial({
          color: new THREE.Color(Color.r / 255, Color.g / 255, Color.b / 255),
          side: THREE.DoubleSide,
          polygonOffset: true,
          polygonOffsetFactor: 1,
          polygonOffsetUnits: 1,
        });
      }
    } else {
      material = new THREE.MeshBasicMaterial({
        color: new THREE.Color(Color.r / 255, Color.g / 255, Color.b / 255),
        side: THREE.DoubleSide,
        polygonOffset: true,
        polygonOffsetFactor: 1,
        polygonOffsetUnits: 1,
      });
    }

    materials.push(material);
  }

  const faceMaterial = new THREE.MeshFaceMaterial(materials);
  faceMaterial.type = "MeshFaceMaterial";
  const mesh = new THREE.Mesh(geometry, faceMaterial);

  setTimeout(() => {
    if (mesh.material.materials && mesh.material.materials[4]) {
      const leftMat = mesh.material.materials[4];
      leftMat.needsUpdate = true;
      if (leftMat.map) leftMat.map.needsUpdate = true;
      console.log(`[left材质延迟更新] 保持原有效果`);
    }
    if (mesh.material.materials && mesh.material.materials[0]) {
      const topMat = mesh.material.materials[0];
      topMat.needsUpdate = true;
      if (topMat.map) topMat.map.needsUpdate = true;
      console.log(`[top材质延迟更新] 同步UV实现的back镜像+90度旋转`);
    }
    rlThreeObj.Trenderer.render(rlThreeObj.Tscene, rlThreeObj.Tcamera);
  }, 500);

  return mesh;
}

function processCrackTexture(
  image,
  defaultBaseColor,
  emissiveColor,
  mirrorCount = 0,
  orientation
) {
  // console.log("defaultBaseColor", defaultBaseColor);
  // debugLog(
  //   "处理纹理：尺寸=" +
  //     image.width +
  //     "x" +
  //     image.height +
  //     "，朝向=" +
  //     orientation
  // );

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = image.width;
  canvas.height = image.height;
  let totalMirrorOperations = 0;

  const isTopFace = orientation === "top";
  if (isTopFace) {
    // 🔴 top面不做任何纹理操作，完全靠UV实现镜像+旋转
    console.log(`[top纹理] 不做额外处理，镜像+旋转由UV控制`);
  } else if (mirrorCount >= 1) {
    ctx.save();
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
    totalMirrorOperations++;
  }

  if (orientation === "right" && !isTopFace) {
    if (totalMirrorOperations > 0) {
      ctx.restore();
      ctx.save();
    }
    ctx.translate(canvas.width, 0);
    ctx.scale(-1, 1);
  }

  ctx.drawImage(image, 0, 0);

  if (!isTopFace && (totalMirrorOperations > 0 || orientation === "right")) {
    ctx.restore();
  }

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  const blackThreshold = 5;

  // 从 RGBA 对象中获取基础色分量
  const baseR = defaultBaseColor.r;
  const baseG = defaultBaseColor.g;
  const baseB = defaultBaseColor.b;
  const baseA = 255;

  // 从 RGBA 对象中获取发光色分量
  const crackR = emissiveColor.r;
  const crackG = emissiveColor.g;
  const crackB = emissiveColor.b;
  const crackA = 255;

  for (let i = 0; i < data.length; i += 4) {
    const isBlackLine =
      data[i] < blackThreshold &&
      data[i + 1] < blackThreshold &&
      data[i + 2] < blackThreshold;
    if (!isBlackLine) {
      data[i] = baseR;
      data[i + 1] = baseG;
      data[i + 2] = baseB;
      data[i + 3] = baseA; // 使用 RGBA 的 alpha 值
    }
  }

  const tempData = new Uint8ClampedArray(data);
  const width = canvas.width;
  const height = canvas.height;
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const idx = (y * width + x) * 4;
      const isBaseColor =
        tempData[idx] === baseR &&
        tempData[idx + 1] === baseG &&
        tempData[idx + 2] === baseB &&
        tempData[idx + 3] === baseA; // 包含 alpha 检测
      if (isBaseColor) {
        let hasCrackNeighbor = false;
        for (let dy = -1; dy <= 1; dy++) {
          for (let dx = -1; dx <= 1; dx++) {
            if (dx === 0 && dy === 0) continue;
            const nx = x + dx;
            const ny = y + dy;
            if (nx >= 0 && nx < width && ny >= 0 && ny < height) {
              const nidx = (ny * width + nx) * 4;
              if (
                tempData[nidx] < blackThreshold &&
                tempData[nidx + 1] < blackThreshold &&
                tempData[nidx + 2] < blackThreshold
              ) {
                hasCrackNeighbor = true;
                break;
              }
            }
          }
          if (hasCrackNeighbor) break;
        }
        if (hasCrackNeighbor) {
          data[idx] = crackR;
          data[idx + 1] = crackG;
          data[idx + 2] = crackB;
          data[idx + 3] = crackA; // 使用发光色的 alpha 值
        }
      }
    }
  }
  ctx.putImageData(imageData, 0, 0);
  // document.body.append(canvas);
  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;
  texture.needsUpdate = true;
  texture.version = Date.now();

  return texture;
}

function loadCubeFaceTexture(
  path,
  defaultBaseColor,
  emissiveColor,
  faceIndex,
  geometry
) {
  return new Promise((resolve) => {
    if (!path || !path.trim()) {
      resolve({ hasImage: false, texture: null });
      return;
    }

    const isLeftFace = faceIndex === 4;
    const isTopFace = faceIndex === 0;
    console.log(
      `[纹理加载] 面索引=${faceIndex}，是否left面=${isLeftFace}，是否top面=${isTopFace}`
    );

    const imageLoader = new THREE.ImageLoader();
    imageLoader.crossOrigin = "anonymous";

    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 10000);
    const loadPath = path + `?t=${timestamp}&r=${random}`;
    imageLoader.load(
      loadPath,
      (image) => {
        let orientation = "unknown";
        if (geometry?.groups[faceIndex]) {
          orientation =
            geometry.groups[faceIndex].userData.orientation || "unknown";
        }

        let mirrorCount = 0;
        if ([0, 2, 4].includes(faceIndex)) {
          mirrorCount = 1;
        } else if (faceIndex === 5) {
          mirrorCount = 2;
        }

        const texture = processCrackTexture(
          image,
          defaultBaseColor,
          emissiveColor,
          mirrorCount,
          orientation
        );

        texture.center.set(0.5, 0.5);
        let rotation = 0;
        if (geometry?.groups[faceIndex]) {
          const rotationRule = rotationRules[orientation];
          if (typeof rotationRule === "function") {
            rotation = rotationRule([], orientation);
          } else {
            rotation = rotationRule || 0;
          }
        }

        if (isLeftFace) {
          rotation = Math.PI;
          // console.log(`[left旋转] 强制旋转180°（保持原有）`);
        }

        texture.rotation = rotation;
        texture.needsUpdate = true;
        texture.version++;
        texture.needsUpdate = true;

        // debugLog(
        //   "面" +
        //     (faceIndex + 1) +
        //     " → 旋转" +
        //     (rotation * 180) / Math.PI +
        //     "°" +
        //     (isLeftFace
        //       ? "（left面原有配置）"
        //       : isTopFace
        //       ? "（top面旋转仅为镜像，UV实现90度旋转）"
        //       : "")
        // );

        resolve({ hasImage: true, texture });
      },
      undefined,
      (err) => {
        // debugLog("纹理加载失败：" + err);
        resolve({ hasImage: false, texture: null });
      }
    );
  });
}

function getFaceOrientation(faceVertices) {
  const { threshold, axes } = coordConfig;

  const v0 = faceVertices[0];
  const v1 = faceVertices[1];
  const v2 = faceVertices[2];
  const edge1 = { x: v1.x - v0.x, y: v1.y - v0.y, z: v1.z - v0.z };
  const edge2 = { x: v2.x - v0.x, y: v2.y - v0.y, z: v2.z - v0.z };
  const normal = {
    x: edge1.y * edge2.z - edge1.z * edge2.y,
    y: edge1.z * edge2.x - edge1.x * edge2.z,
    z: edge1.x * edge2.y - edge1.y * edge2.x,
  };

  const normalMagnitude = Math.sqrt(
    Math.pow(normal.x, 2) + Math.pow(normal.y, 2) + Math.pow(normal.z, 2)
  );
  if (normalMagnitude < 0.0001) return "unknown";

  const unitNormal = {
    x: normal.x / normalMagnitude,
    y: normal.y / normalMagnitude,
    z: normal.z / normalMagnitude,
  };

  for (const [orient, config] of Object.entries(axes)) {
    const dotProduct = unitNormal[config.axis] * config.direction;
    if (dotProduct >= threshold) {
      return orient;
    }
  }
  return "unknown";
}

/**
 * 测试数据 → 对齐参考数据格式的转换函数
 * @param {Object} testData - 输入的测试数据（含points和faces）
 * @param {Object} refData - 参考数据（含points和faces，提供顶点顺序和面索引规则）
 * @returns {Object} 转换后的数据（顶点顺序+面索引=参考数据，位置+尺寸=测试数据）
 */
function convertToRefFormat(
  testData,
  refData = {
    points: [
      36166.93, 28560.19, 3300, 34546.93, 28560.19, 3300, 34546.93, 28560.19,
      2900, 36166.93, 28560.19, 2900, 36166.93, 28760.19, 3300, 36166.93,
      28760.19, 2900, 34546.93, 28760.19, 3300, 34546.93, 28760.19, 2900,
    ],
    faces: [
      0, 1, 2, 0, 2, 3, 4, 0, 3, 4, 3, 5, 6, 4, 5, 6, 5, 7, 1, 6, 7, 1, 7, 2, 4,
      1, 0, 4, 6, 1, 5, 2, 3, 5, 7, 2,
    ],
  }
) {
  // -------------------------- 步骤1：解析测试数据的关键极值（保留位置和尺寸）--------------------------
  const testPoints = testData.points;
  const vertices = []; // 拆分测试数据的8个顶点为 [x,y,z] 数组
  for (let i = 0; i < testPoints.length; i += 3) {
    vertices.push([testPoints[i], testPoints[i + 1], testPoints[i + 2]]);
  }

  // 计算测试数据的 X/Y/Z 极值（决定立方体位置和尺寸）
  const xs = vertices.map((v) => v[0]);
  const ys = vertices.map((v) => v[1]);
  const zs = vertices.map((v) => v[2]);
  const Xmin = Math.min(...xs);
  const Xmax = Math.max(...xs);
  const Ymin = Math.min(...ys);
  const Ymax = Math.max(...ys);
  const Zmin = Math.min(...zs);
  const Zmax = Math.max(...zs);

  // -------------------------- 步骤2：按参考数据的顶点顺序规则，生成新顶点 --------------------------
  // 先解析参考数据，固化顶点顺序规则（V0-V7的定义，从参考数据中提取的通用规则）
  const refVertices = [];
  for (let i = 0; i < refData.points.length; i += 3) {
    refVertices.push([
      refData.points[i],
      refData.points[i + 1],
      refData.points[i + 2],
    ]);
  }
  // 分析参考数据的顶点规则（V0-V7 对应 X/Y/Z 的逻辑关系）
  const refVertexRules = getRefVertexRules(refVertices);

  // 按参考规则，用测试数据的极值生成新顶点（顺序完全对齐参考）
  const newPoints = [];
  refVertexRules.forEach((rule) => {
    let x = rule.x === "max" ? Xmax : Xmin;
    let y = rule.y === "max" ? Ymax : Ymin;
    let z = rule.z === "max" ? Zmax : Zmin;
    newPoints.push(x, y, z);
  });

  // -------------------------- 步骤3：复用参考数据的面索引 --------------------------
  const newFaces = [...refData.faces];

  return { points: newPoints, faces: newFaces };
}

/**
 * 辅助函数：从参考数据中提取顶点顺序规则（V0-V7 对应 X/Y/Z 的 max/min 关系）
 * @param {Array} refVertices - 参考数据的顶点数组（8个 [x,y,z] 元素）
 * @returns {Array} 每个顶点的规则（如 {x: 'max', y: 'min', z: 'max'}）
 */
function getRefVertexRules(refVertices) {
  const xs = refVertices.map((v) => v[0]);
  const ys = refVertices.map((v) => v[1]);
  const zs = refVertices.map((v) => v[2]);
  const XminRef = Math.min(...xs);
  const XmaxRef = Math.max(...xs);
  const YminRef = Math.min(...ys);
  const YmaxRef = Math.max(...ys);
  const ZminRef = Math.min(...zs);
  const ZmaxRef = Math.max(...zs);

  // 为每个参考顶点定义规则（x/y/z 是 max 还是 min）
  return refVertices.map((v) => ({
    x: v[0] === XmaxRef ? "max" : "min",
    y: v[1] === YmaxRef ? "max" : "min",
    z: v[2] === ZmaxRef ? "max" : "min",
  }));
}

/**
 * 判断长方体数据是否沿 X 轴延伸（X轴为最长轴）
 * @param {number[]} points - Three.js 格式的顶点数组（8个顶点×3个坐标=24个数值）
 * @param {boolean} [allowEqual=false] - 是否允许 X 轴长度与其他轴相等（默认不允许，必须严格最长）
 * @returns {Object} 结果对象：isXAxisExtended（是否沿X轴延伸）、axisLengths（各轴长度）
 */
function isExtendedAlongXAxis(points, allowEqual = false) {
  // -------------------------- 1. 输入校验（避免无效数据）--------------------------
  if (!Array.isArray(points) || points.length !== 24) {
    console.error("错误：points 必须是长度为24的数组（8个顶点×3个坐标）");
    return {
      isXAxisExtended: false,
      axisLengths: { x: 0, y: 0, z: 0 },
    };
  }

  // 验证所有元素都是数字
  const allNumbers = points.every(
    (item) => typeof item === "number" && !isNaN(item)
  );
  if (!allNumbers) {
    console.error("错误：points 数组必须包含纯数字");
    return {
      isXAxisExtended: false,
      axisLengths: { x: 0, y: 0, z: 0 },
    };
  }

  // -------------------------- 2. 拆分 X/Y/Z 坐标列表 --------------------------
  const xCoords = []; // 所有顶点的X坐标
  const yCoords = []; // 所有顶点的Y坐标
  const zCoords = []; // 所有顶点的Z坐标

  // 遍历 points，每3个元素为一组（一个顶点的X/Y/Z）
  for (let i = 0; i < points.length; i += 3) {
    xCoords.push(points[i]);
    yCoords.push(points[i + 1]);
    zCoords.push(points[i + 2]);
  }

  // -------------------------- 3. 计算三个轴的长度（max - min）--------------------------
  const getAxisLength = (coords) => Math.max(...coords) - Math.min(...coords);
  const xLength = getAxisLength(xCoords);
  const yLength = getAxisLength(yCoords);
  const zLength = getAxisLength(zCoords);

  // -------------------------- 4. 判断是否沿 X 轴延伸 --------------------------
  let isXAxisExtended = false;
  if (allowEqual) {
    // 允许 X 轴长度与其他轴相等（≥ 其他轴长度）
    isXAxisExtended = xLength >= yLength && xLength >= zLength;
  } else {
    // 严格要求 X 轴长度是最长的（> 其他轴长度）
    isXAxisExtended = xLength > yLength && xLength > zLength;
  }

  // -------------------------- 5. 返回结果 --------------------------
  return {
    isXAxisExtended: isXAxisExtended,
    axisLengths: {
      x: xLength.toFixed(2), // 保留2位小数，更易读
      y: yLength.toFixed(2),
      z: zLength.toFixed(2),
    },
    debugInfo: {
      xMin: Math.min(...xCoords).toFixed(2),
      xMax: Math.max(...xCoords).toFixed(2),
      yMin: Math.min(...yCoords).toFixed(2),
      yMax: Math.max(...yCoords).toFixed(2),
      zMin: Math.min(...zCoords).toFixed(2),
      zMax: Math.max(...zCoords).toFixed(2),
    },
  };
}

/**
 * 强制统一所有数据到基础参考格式（顶点顺序、X/Y/Z排列、面索引完全对齐）
 * @param {Object} testData - 输入的测试数据（含points和faces）
 * @param {Object} baseRefData - 基础参考数据（你的标准格式）
 * @returns {Object} 标准化后的数据（与基础参考格式完全一致）
 */
function convertToBaseRefFormat(
  testData,
  baseRefData = {
    points: [
      36166.93, 28560.19, 3300, 34546.93, 28560.19, 3300, 34546.93, 28560.19,
      2900, 36166.93, 28560.19, 2900, 36166.93, 28760.19, 3300, 36166.93,
      28760.19, 2900, 34546.93, 28760.19, 3300, 34546.93, 28760.19, 2900,
    ],
    faces: [
      0, 1, 2, 0, 2, 3, 4, 0, 3, 4, 3, 5, 6, 4, 5, 6, 5, 7, 1, 6, 7, 1, 7, 2, 4,
      1, 0, 4, 6, 1, 5, 2, 3, 5, 7, 2,
    ],
  }
) {
  // -------------------------- 步骤1：解析测试数据的关键极值（保留实际位置和尺寸）--------------------------
  const testPoints = testData.points;
  const testVertices = [];
  // 拆分测试数据为8个顶点（[x,y,z]格式）
  for (let i = 0; i < testPoints.length; i += 3) {
    testVertices.push([testPoints[i], testPoints[i + 1], testPoints[i + 2]]);
  }

  // 计算测试数据的X/Y/Z极值（决定实际位置和尺寸，不改变）
  const xs = testVertices.map((v) => v[0]);
  const ys = testVertices.map((v) => v[1]);
  const zs = testVertices.map((v) => v[2]);
  const Xmin = Math.min(...xs);
  const Xmax = Math.max(...xs);
  const Ymin = Math.min(...ys);
  const Ymax = Math.max(...ys);
  const Zmin = Math.min(...zs);
  const Zmax = Math.max(...zs);

  // -------------------------- 步骤2：提取基础参考数据的「顶点规则」（核心）--------------------------
  // 解析基础参考数据的8个顶点
  const baseVertices = [];
  for (let i = 0; i < baseRefData.points.length; i += 3) {
    baseVertices.push([
      baseRefData.points[i],
      baseRefData.points[i + 1],
      baseRefData.points[i + 2],
    ]);
  }

  // 提取基础参考数据每个顶点的「X/Y/Z属性规则」（每个顶点是max还是min的组合）
  // 例如：baseVertexRules[0] = {x: 'max', y: 'min', z: 'max'} → 基础数据第0个顶点是Xmax、Ymin、Zmax
  const baseVertexRules = baseVertices.map((vertex) => {
    const baseXmin = Math.min(...baseVertices.map((v) => v[0]));
    const baseXmax = Math.max(...baseVertices.map((v) => v[0]));
    const baseYmin = Math.min(...baseVertices.map((v) => v[1]));
    const baseYmax = Math.max(...baseVertices.map((v) => v[1]));
    const baseZmin = Math.min(...baseVertices.map((v) => v[2]));
    const baseZmax = Math.max(...baseVertices.map((v) => v[2]));

    return {
      x: vertex[0] === baseXmax ? "max" : "min",
      y: vertex[1] === baseYmax ? "max" : "min",
      z: vertex[2] === baseZmax ? "max" : "min",
    };
  });

  // -------------------------- 步骤3：按基础规则生成「标准化顶点」（完全对齐基础数据）--------------------------
  const standardizedPoints = [];
  // 基础参考数据有8个顶点，按顺序生成每个顶点（强制对齐规则）
  baseVertexRules.forEach((rule) => {
    // 按基础规则分配测试数据的极值（X/Y/Z属性与基础数据完全一致）
    const x = rule.x === "max" ? Xmax : Xmin;
    const y = rule.y === "max" ? Ymax : Ymin;
    const z = rule.z === "max" ? Zmax : Zmin;
    standardizedPoints.push(x, y, z);
  });

  // -------------------------- 步骤4：复用基础参考数据的「面索引」（完全统一）--------------------------
  const standardizedFaces = [...baseRefData.faces];

  // -------------------------- 日志验证（可选，用于调试）--------------------------
  console.log(
    `[数据标准化] 完成：顶点数=${standardizedPoints.length / 3}，面索引数=${
      standardizedFaces.length
    }`
  );
  console.log(
    `[数据标准化] 原始极值：X[${Xmin},${Xmax}] Y[${Ymin},${Ymax}] Z[${Zmin},${Zmax}]`
  );

  return {
    points: standardizedPoints,
    faces: standardizedFaces,
  };
}

// 辅助函数：验证标准化结果（可选，用于确认是否与基础格式一致）
function verifyStandardization(result, baseRefData) {
  const isPointsLengthMatch =
    result.points.length === baseRefData.points.length;
  const isFacesMatch =
    JSON.stringify(result.faces) === JSON.stringify(baseRefData.faces);
  console.log(
    `[标准化验证] 顶点长度匹配：${isPointsLengthMatch}，面索引匹配：${isFacesMatch}`
  );
  return isPointsLengthMatch && isFacesMatch;
}
